import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { UserService } from "../../services/user.service";
declare var $: any;
import { LoaderModalService } from "../../services/loader.service";
import { CommonService } from "src/app/services/common.service";
import { Store } from "@ngrx/store";
import { AppState } from "state/app.state";
import * as Actions from "state/app.actions";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
})
export class FooterComponent implements OnInit {
  auth: any;
    @ViewChild('footerEl') footerEl!: ElementRef<HTMLElement>;

  year = new Date().getFullYear();
  apkRequestFormGroup: FormGroup;
  deviceType: string;
  footerContent: any;
  usefulLinks: any = [];
  store: any;
  siteDada: any;
  contactPage: any = "";
  storeInfo: any = "";
  constructor(
    private userSrv: UserService, 
    private router: Router, 
    private fb: FormBuilder, 
    private ls: LoaderModalService, 
    private commonService: CommonService, 
    private storeState: Store<AppState>
  ) {
  
    let footerContent = JSON.parse(sessionStorage.getItem("footerContent"));
    if (footerContent != undefined && footerContent != "" && footerContent != null) {
      this.footerContent = footerContent;
    }
    let storeInfo = JSON.parse(localStorage.getItem("storeInfo"));
    if (storeInfo != undefined && storeInfo != "" && storeInfo != null) {
      this.storeInfo = storeInfo;      
    }
    let siteContent = JSON.parse(sessionStorage.getItem("contactData"));
    if (siteContent != null) {
      this.contactPage = siteContent;
    }
    let usefulLinks = JSON.parse(sessionStorage.getItem("usefulLinks"));
    if (usefulLinks != undefined && usefulLinks != "" && usefulLinks != null) {
      this.usefulLinks = usefulLinks;
    }
    setTimeout(() => {
      this.siteDada = JSON.parse(localStorage.getItem("siteData"));
    }, 300);

    this.getHomeContant();
    this.createApkRequestFormGroup();
  }


  
  ngOnInit(): void {
    this.storeFilter(localStorage.getItem("localStoreId"));
    this.store = localStorage.getItem("storeName");
    if (this.store == null || this.store == undefined) {
      this.store = "";
    }

    this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {});
    this.userSrv.getAuth().subscribe((res) => {
      this.auth = res;
    });
  }
  getColor() {
    let style: any;
    if (this.siteDada?.footerColor) {
      style = { background: this.siteDada?.footerColor };
    } else {
      style = { background: "#000" };
    }
    return style;
  }
  getHomeContant() {
    this.commonService.getHOmeContent().subscribe((res: any) => {
      if (res["meta"]["status"]) {
        sessionStorage.setItem("ageVerification", JSON.stringify(res["data"]["ageVerification"]));
        sessionStorage.setItem("footerContent", JSON.stringify(res["data"]["footer"]));
        this.footerContent = JSON.parse(sessionStorage.getItem("footerContent"));
        sessionStorage.setItem("usefulLinks", JSON.stringify(res["data"]["footer"]["usefulLinks"]));
        this.usefulLinks = JSON.parse(sessionStorage.getItem("usefulLinks"));
        this.storeState.dispatch(
          new Actions.Add({
            data: res?.data,
            productDetailPageData: res?.productDetailPageData,
            userRegPageData: res?.userRegPageData,
          })
        );
      }
    });
  }

  createApkRequestFormGroup() {
    this.apkRequestFormGroup = this.fb.group({
      userName: ["", Validators.required],
      emailId: ["", [Validators.required, Validators.email]],
      mobileNumber: ["", Validators.required],
    });
  }

  routeToUrls(url) {
    this.router.navigateByUrl(`${this.store}/${url}`);
  }
  routeToDash() {
    this.router.navigateByUrl(`${this.store}/dashboard/profile`);
  }

  openApkModal(deviceType: string) {
    this.deviceType = deviceType;
    $("#apkRequestModal").modal("show");
    $("#apkRequestModal").on("hidden.bs.modal", (event) => {
      this.deviceType = undefined;
      this.apkRequestFormGroup.reset();
    });
  }

  hideApkModal() {
    $("#apkRequestModal").modal("hide");
  }

  submitApkRequest() {
    if (this.apkRequestFormGroup.valid) {
      this.ls.startLoader("", "");
      let obj = {
        applicationType: this.deviceType === "ios" ? "IOS" : "Android",
        ...this.apkRequestFormGroup.value,
      };
      this.commonService.submitApkRequest(obj).subscribe((data: any) => {
        if (data.meta.status) {
          this.ls.changeStateandStopLoader("success", data.meta.msg, 2000);
          this.hideApkModal();
        } else {
          this.ls.changeStateandStopLoader("error", data.meta.msg, 3000);
        }
      });
    }
  }

  generatePhoneNumber() {
    let mobile = this.getStoreMObile()
    const match = mobile.match(/^(\d{3})(\d{3})(\d{4})$/);    
    if (mobile && match?.length > 0) {
      const phoneNumber = `(${match[1]})${match[2]}-${match[3]}`;
      return phoneNumber;
    }
  }

  openLogin() {
    document.getElementById("mySideRegister").style.width = "0";
    document.getElementById("mySideLogin").style.width = "350px";
    function myFunction(x) {
      if (x.matches) {
        document.getElementById("mySideLogin").style.width = "calc(100%)";
      }
    }
    var x = window.matchMedia("(max-width: 580px)");
    myFunction(x);
    x.addEventListener("click", myFunction); // Attach listener function on state changes
    const modal=  document.getElementById("mySideLogin")
    modal.focus()
  }

  openRegister() {
    document.getElementById("mySideLogin").style.width = "0";
    document.getElementById("mySideRegister").style.width = "450px";
    function myFunction(x) {
      if (x.matches) {
        document.getElementById("mySideRegister").style.width = "calc(100%)";
      }
    }
    var x = window.matchMedia("(max-width: 580px)");
    myFunction(x);
    x.addEventListener("click", myFunction); // Attach listener function on state changes
    const modal=  document.getElementById("mySideRegister")
    modal.focus()
  }
  openLogoutPopUp() {
    $("#logoutPopUp").modal("show");
  }

  checkAddress(item) {
    return item ? item : "";
  }

  checkDeliveryDay() {
    const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let today: any = new Date();
    if (today != null && today != undefined && today != "" && this.storeInfo?.StoreHours != undefined) {
      let dayz = weekday[today?.getDay()];
      let value;
      if (dayz) {
        value = this.storeInfo?.StoreHours[dayz];
      }
      let hrEle = value["Open"]["Hour"];
      let minEle = value["Open"]["Minute"];
      if (hrEle >= 0 && hrEle <= 24 && minEle >= 0 && minEle <= 60) {
        let AMorPM = "AM";
        if (hrEle > 12) AMorPM = "PM";
        hrEle = hrEle % 12;
      }
      let hrEle1 = value["Close"]["Hour"];
      let minEle1 = value["Close"]["Minute"];
      if (hrEle1 >= 0 && hrEle1 <= 24 && minEle1 >= 0 && minEle1 <= 60) {
        let AMorPM = "AM";
        if (hrEle1 > 12) AMorPM = "PM";
        hrEle1 = hrEle1 % 12;
      }
      if (hrEle != 0) {
        return hrEle + "am" + " - " + hrEle1 + "pm";
      } else {
        return "12" + "pm" + " - " + hrEle1 + "pm";
      }
    }
  }
  displayStorePhone: any = "";
  DisplayStoreName: any;
  storeData: any;
  storeFilter(id) {
    let obj = {
      Id: id,
    };
    this.commonService.getStoreDetail(obj).subscribe((res) => {
      if (res["meta"]["status"]) {
        this.storeData = res["data"];
        let city = res["data"].Address.City;
        let name = res["data"].Name;
        let open = {
          hour: res["data"].StoreHours.Monday.Open.Hour,
          minute: res["data"].StoreHours.Monday.Open.Minute,
        };
        let close = {
          hour: res["data"].StoreHours.Monday.Close.Hour,
          minute: res["data"].StoreHours.Monday.Close.Minute,
        };
        this.DisplayStoreName = city + " - " + name + " Store";
        this.phoneFormat(this.storeData.storeMobile);
      }
    });
  }
  phoneFormat(input) {
    //returns (###) ###-####
    input = input.replace(/\D/g, "");
    var size = input.length;
    if (size > 0) {
      input = "(" + input;
    }
    if (size > 3) {
      input = input.slice(0, 4) + ") " + input.slice(4, 11);
    }
    if (size > 6) {
      input = input.slice(0, 9) + "-" + input.slice(9);
    }
    this.displayStorePhone = input;
  }

  getStoreMObile() {
    if (this.contactPage?.phone) {
      return this.contactPage?.phone;
    } else {
      return this.displayStorePhone;
    }
  }
}
